import * as yup from 'yup';
import { GalleriesEnum_class } from '../../common/enums/galleries';
import { LanguagesEnum_class } from '../../common/enums/languages';

export interface ExhibitDto {
    id?: string,
    gallery: string,
    galleryId: number,
    name: string,
    description: string,
    startDate?: Date,
    endDate?: Date,
    isActive: boolean,
    qrCode: string,
    content: ExhibitContentDto[],
    thumbnail?: string,
    fileUpload?: File[],
    dateRequired: boolean
}

export interface ExhibitContentDto {
    id?: string,
    languageId: number,
    content: string,
    exhibitId: string
}

export const exhibitContentArrayInit: ExhibitContentDto[] = [
    {
        id: '',
        languageId: LanguagesEnum_class.enum.English,
        content: '',
        exhibitId: ''
    },
    {
        id: '',
        languageId: LanguagesEnum_class.enum.Spanish,
        content: '',
        exhibitId: ''
    }
]

export const exhibitContentInit: ExhibitContentDto = 
    {
        id: '',
        languageId: 0,
        content: '',
        exhibitId: ''
    }

export const exhibitInit: ExhibitDto = {
    id: '',
    gallery: '',
    galleryId: 0,
    name: '',
    description: '',
    isActive: true,
    qrCode: '',
    content: exhibitContentArrayInit,
    fileUpload: [],
    dateRequired: false,
    thumbnail: ''
}

export const exhibitValidationSchema = yup.object().shape({
    galleryId: yup.mixed().oneOf(Object.values(GalleriesEnum_class.enum), 'Please select a gallery.').required('Please select a gallery.'),
    name: yup.string().required("Please enter an exhibit name."),
    description: yup.string().required("Please enter a description."),
    startDate: yup.date().when('dateRequired', {
        is: true,
        then: yup.date()
        .required('Please enter a start date.'),
        otherwise: yup.date(),
     }),
     endDate: yup.date().when('dateRequired', {
        is: true,
        then: yup.date().min(
            yup.ref("startDate"),
            "End date must be greater than start date"
          )
        .required('Please enter an end date.'),
        otherwise: yup.date(),
     }),
});